// extracted by mini-css-extract-plugin
export default {"showcase":"showcase__R8tAi","desc":"desc__dbAJB","link":"link__I2jZf"};